import React from 'react';
import './Loader.css';

const Loader = ({
  fullscreen = false,
  title = 'Loading',
  subtitle = '',
}) => {
  const rootClassName = [
    'app-loader',
    fullscreen ? 'app-loader--fullscreen' : 'app-loader--page',
  ].join(' ');

  return (
    <div
      className={rootClassName}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={title}
    >
      <div className="app-loader__glow app-loader__glow--left" />
      <div className="app-loader__glow app-loader__glow--right" />

      <div className="app-loader__core">
        <div className="app-loader__mark" aria-hidden="true">
          <div className="app-loader__halo" />
          <div className="app-loader__logo-wrap">
            <div className="app-loader__logo-sheen" />
          </div>

          <img
            className="app-loader__logo-image"
            src="assets/layout/images/nhl-logo.png"
            alt=""
          />
        </div>

        <div className="app-loader__eyebrow">NHL Hub</div>
        {title ? <div className="app-loader__title">{title}</div> : null}
        {subtitle ? <p className="app-loader__subtitle">{subtitle}</p> : null}

        <div className="app-loader__visual" aria-hidden="true">
          <div className="app-loader__rail">
            <span className="app-loader__rail-sweep" />
          </div>
          <div className="app-loader__rail-glow" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
